// extracted by mini-css-extract-plugin
export default {"row":"byMXDW7OpsXs9UHs2Ucq","label":"I0ClfCADGyhMx3p_hOyQ"};